var map = {
	"./en/deployment.json": 3064,
	"./en/footer.json": 8172,
	"./en/header.json": 1514,
	"./en/home.json": 4820,
	"./en/impulse.json": 5754,
	"./en/project.json": 8260,
	"./en/projectpage.json": 2815,
	"./en/pump.json": 7385,
	"./en/sdg.json": 2633,
	"./en/team.json": 594,
	"./en/testimony.json": 7375,
	"./en/video.json": 6430,
	"./fr/deployment.json": 3485,
	"./fr/footer.json": 7401,
	"./fr/header.json": 4227,
	"./fr/home.json": 2801,
	"./fr/impulse.json": 1049,
	"./fr/project.json": 3,
	"./fr/projectpage.json": 8520,
	"./fr/pump.json": 6956,
	"./fr/sdg.json": 170,
	"./fr/team.json": 7483,
	"./fr/testimony.json": 3212,
	"./fr/video.json": 8581,
	"./pt/deployment.json": 61,
	"./pt/footer.json": 2729,
	"./pt/header.json": 4163,
	"./pt/home.json": 3089,
	"./pt/impulse.json": 4265,
	"./pt/project.json": 2819,
	"./pt/projectpage.json": 8024,
	"./pt/pump.json": 8204,
	"./pt/sdg.json": 8394,
	"./pt/team.json": 7931,
	"./pt/testimony.json": 908,
	"./pt/video.json": 8117,
	"./sw/deployment.json": 151,
	"./sw/footer.json": 931,
	"./sw/header.json": 9521,
	"./sw/home.json": 6495,
	"./sw/impulse.json": 4291,
	"./sw/project.json": 3753,
	"./sw/projectpage.json": 2698,
	"./sw/pump.json": 1630,
	"./sw/sdg.json": 5376,
	"./sw/team.json": 8109,
	"./sw/testimony.json": 3870,
	"./sw/video.json": 8403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4808;